export const HUBSPOT_PORTAL_ID = '598786'

export const HUBSPOT_REGION = 'na1'
export const HUBSPOT_INQUIRY_FORM_ID = '2d855765-9233-4d34-8fc5-a3baec870491'

// ポータル単位の埋め込みローダー。DOM 上の div.hs-form-frame を走査してフォームを描画する
export const HUBSPOT_FORMS_SCRIPT_SRC = `https://js.hsforms.net/forms/embed/${HUBSPOT_PORTAL_ID}.js`
